import React, { useMemo } from 'react';
import { useStores } from '@stores';
import { observer } from 'mobx-react-lite';
import { IconWrapper, NumberBox } from './styles';
import BasketIcon from '@app/assets/basketIcon';

const HeaderBookmarks = () => {
  const {
    bookmarksStore: { bookmarksData },
  } = useStores();

  const bookmarksCount = useMemo(() => bookmarksData?.length, [bookmarksData]);

  return (
    <IconWrapper>
      <BasketIcon />
      <NumberBox>{bookmarksCount}</NumberBox>
    </IconWrapper>
  );
};

export default observer(HeaderBookmarks);
